<div class="relative flex flex-col w-full min-h-full max-h-full bg-white dark:bg-gray-900">

  <!-- Krok 1: Ekran powitalny -->
  <ng-container *ngIf="activeStep == 1">
    <div class="flex flex-col items-center justify-center min-h-[500px] p-8">
      
      <!-- Logo i powitanie -->
      <div class="text-center mb-8">
        <div class="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center shadow-lg">
          <mat-icon [svgIcon]="'tabler_outline:building-skyscraper'" class="!w-10 !h-10 text-white"></mat-icon>
        </div>
        <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          Witaj w Fakturnia.pl 👋
        </h1>
        <p class="text-gray-600 dark:text-gray-400 max-w-md">
          Cieszymy się, że do nas dołączyłeś. Podaj NIP swojej firmy, a my automatycznie pobierzemy dane z bazy GUS.
        </p>
      </div>

      <!-- Formularz NIP -->
      <div class="w-full max-w-sm">
        <div class="bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>NIP Twojej firmy</mat-label>
            <mat-icon matPrefix [svgIcon]="'tabler_outline:id'" class="text-gray-400 mr-2"></mat-icon>
            <input #nipControl [formControl]="firstForm.controls.nip" numericOnly matInput
              placeholder="np. 1234567890" maxlength="10" (blur)="checkNipOnBlur()">
            <mat-icon *ngIf="checkingNip" matSuffix class="icn-spinner text-gray-400" [svgIcon]="'tabler_outline:loader'"></mat-icon>
            <mat-icon *ngIf="nipAvailable === true && !checkingNip" matSuffix class="text-green-500" [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
            <mat-icon *ngIf="nipAvailable === false && !checkingNip" matSuffix class="text-red-500" [svgIcon]="'tabler_outline:circle-x'"></mat-icon>
            <mat-error *ngIf="firstForm.controls.nip.touched && firstForm.controls.nip.hasError('required')">NIP jest wymagany</mat-error>
            <mat-error *ngIf="firstForm.controls.nip.touched && firstForm.controls.nip.hasError('minlength')">NIP musi mieć 10 cyfr</mat-error>
            <mat-error *ngIf="firstForm.controls.nip.touched && firstForm.controls.nip.hasError('notfound')">Nie znaleziono firmy o podanym NIP</mat-error>
            <mat-error *ngIf="firstForm.controls.nip.touched && firstForm.controls.nip.hasError('nipTaken')">Ten NIP jest już przypisany do innego konta</mat-error>
          </mat-form-field>

          <button mat-flat-button color="primary" class="w-full h-12 text-base" [disabled]="loading || nipAvailable === false" (click)="search()">
            <mat-icon *ngIf="loading" class="icn-spinner mr-2" [svgIcon]="'tabler_outline:loader'"></mat-icon>
            <mat-icon *ngIf="!loading" class="mr-2" [svgIcon]="'tabler_outline:search'"></mat-icon>
            <span *ngIf="!loading">Wyszukaj automatycznie</span>
            <span *ngIf="loading">Szukam danych firmy...</span>
          </button>
        </div>

        <!-- Separator -->
        <div class="relative my-6">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-4 bg-white dark:bg-gray-900 text-gray-500">lub</span>
          </div>
        </div>

        <!-- Przycisk ręcznego wypełnienia -->
        <button mat-stroked-button class="w-full" [disabled]="loading" (click)="activeStep = 2">
          <mat-icon class="mr-2" [svgIcon]="'tabler_outline:pencil'"></mat-icon>
          Wypełnij dane ręcznie
        </button>
      </div>

      <!-- Wyloguj się -->
      <div class="mt-6 text-center">
        <a (click)="logout()" class="text-sm text-primary-600 dark:text-primary-400 cursor-pointer hover:underline">Wyloguj się</a>
      </div>

      <!-- Trust signals -->
      <div class="mt-8 flex flex-wrap justify-center gap-6 text-sm text-gray-500 dark:text-gray-400">
        <div class="flex items-center gap-2">
          <mat-icon [svgIcon]="'tabler_outline:shield-check'" class="!w-5 !h-5 text-green-500"></mat-icon>
          <span>Dane z bazy GUS</span>
        </div>
        <div class="flex items-center gap-2">
          <mat-icon [svgIcon]="'tabler_outline:clock'" class="!w-5 !h-5 text-blue-500"></mat-icon>
          <span>Zajmie tylko minutę</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Krok 2: Formularz wieloetapowy -->
  <ng-container *ngIf="activeStep == 2">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-3">
          <div class="w-10 h-10 rounded-xl bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
            <mat-icon [svgIcon]="'tabler_outline:building'" class="!w-5 !h-5 text-primary-600 dark:text-primary-400"></mat-icon>
          </div>
          <div>
            <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Konfiguracja konta</h2>
            <p class="text-sm text-gray-500 dark:text-gray-400">Krok {{selectedStepIndex + 1}} z 3</p>
          </div>
        </div>
        <a (click)="logout()" class="text-sm text-primary-600 dark:text-primary-400 cursor-pointer hover:underline whitespace-nowrap">Wyloguj się</a>
      </div>
      <!-- Progress bar -->
      <div class="flex items-center gap-2">
        <div class="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div class="h-full bg-primary-500 transition-all duration-300 rounded-full"
               [style.width.%]="((selectedStepIndex + 1) / 3) * 100"></div>
        </div>
        <span class="text-sm font-medium text-gray-600 dark:text-gray-400">{{((selectedStepIndex + 1) / 3 * 100) | number:'1.0-0'}}%</span>
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto p-6">
      <mat-stepper orientation="vertical" linear="true" (selectionChange)="onStepSelect($event)"
        [selectedIndex]="selectedStepIndex" class="bg-transparent">
        
        <!-- Krok 1: Dane firmy -->
        <mat-step [stepControl]="firstForm" state="edit">
          <ng-template matStepLabel>
            <span class="font-medium">Dane firmy</span>
          </ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4"></mat-icon>
          </ng-template>
          
          <form [formGroup]="firstForm" class="mt-4">
            <div *ngIf="dataLoadedFromGUS" class="mb-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-100 dark:border-green-800">
              <div class="flex items-center gap-2 text-green-700 dark:text-green-300 text-sm">
                <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4"></mat-icon>
                <span>Dane pobrane z bazy GUS. Sprawdź i popraw jeśli potrzeba.</span>
              </div>
            </div>

            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>NIP firmy</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:id'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" formControlName="nip" numericOnly autocomplete="off" placeholder="1234567890" matInput maxlength="10" (blur)="checkNipOnBlur()">
                  <div matSuffix class="flex items-center gap-2 mr-2">
                    <mat-icon *ngIf="checkingNip" class="icn-spinner text-gray-400" [svgIcon]="'tabler_outline:loader'"></mat-icon>
                    <mat-icon *ngIf="nipAvailable === true && !checkingNip && !loading" class="text-green-500" [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
                    <mat-icon *ngIf="nipAvailable === false && !checkingNip && !loading" class="text-red-500" [svgIcon]="'tabler_outline:circle-x'"></mat-icon>
                    <button *ngIf="!loading && !checkingNip" mat-flat-button color="primary" (click)="search()" type="button" [disabled]="nipAvailable === false">
                      <mat-icon [svgIcon]="'tabler_outline:search'" class="!w-4 !h-4 mr-1"></mat-icon>
                      Szukaj
                    </button>
                    <mat-icon *ngIf="loading" class="icn-spinner text-primary-500" [svgIcon]="'tabler_outline:loader'"></mat-icon>
                  </div>
                  <mat-error *ngIf="firstForm.controls.nip.hasError('required')">NIP jest wymagany</mat-error>
                  <mat-error *ngIf="firstForm.controls.nip.hasError('minlength')">Min. 10 cyfr</mat-error>
                  <mat-error *ngIf="firstForm.controls.nip.hasError('notfound')">Nie znaleziono firmy</mat-error>
                  <mat-error *ngIf="firstForm.controls.nip.hasError('nipTaken')">Ten NIP jest już przypisany do innego konta</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Nazwa firmy</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:building'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" formControlName="name" placeholder="Nazwa Twojej firmy" matInput>
                  <mat-error *ngIf="firstForm.controls.name.hasError('required')">Nazwa jest wymagana</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12 sm:col-span-6">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Imię</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:user'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" formControlName="firstName" placeholder="Jan" matInput>
                  <mat-error *ngIf="firstForm.controls.firstName.hasError('required')">Imię jest wymagane</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12 sm:col-span-6">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Nazwisko</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:user'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" formControlName="lastName" placeholder="Kowalski" matInput>
                  <mat-error *ngIf="firstForm.controls.lastName.hasError('required')">Nazwisko jest wymagane</mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>

          <button class="mt-8 h-11" mat-flat-button color="primary" matStepperNext>
            Dalej
            <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5 ml-1"></mat-icon>
          </button>
        </mat-step>

        <!-- Krok 2: Dane kontaktowe -->
        <mat-step [stepControl]="secondForm" label="Dane kontaktowe" state="edit">
          <ng-template matStepperIcon="edit">
            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4"></mat-icon>
          </ng-template>
          
          <form [formGroup]="secondForm" class="mt-4">
            <div class="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800">
              <div class="flex items-start gap-2 text-blue-700 dark:text-blue-300 text-sm">
                <mat-icon [svgIcon]="'tabler_outline:info-circle'" class="!w-4 !h-4 mt-0.5 flex-shrink-0"></mat-icon>
                <span>Numer telefonu służy wyłącznie do zabezpieczenia konta i odzyskiwania dostępu. Nigdy nie wykorzystamy go do celów marketingowych.</span>
              </div>
            </div>

            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Numer telefonu</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:phone'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" phoneNumber formControlName="phoneNumber" placeholder="123 456 789" matInput>
                  <mat-error *ngIf="secondForm.controls.phoneNumber.hasError('required')">Numer jest wymagany</mat-error>
                  <mat-error *ngIf="secondForm.controls['phoneNumber'].hasError('minlength')">Min. 9 cyfr</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Ulica i numer</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:map-pin'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" formControlName="street" placeholder="Przykładowa 10/2" matInput>
                  <mat-error *ngIf="secondForm.controls.street.hasError('required')">Adres jest wymagany</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12 sm:col-span-4">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Kod pocztowy</mat-label>
                  <input type="text" formControlName="postalCode" placeholder="00-000" matInput>
                  <mat-error *ngIf="secondForm.controls['postalCode'].hasError('required')">Wymagane</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12 sm:col-span-8">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Miejscowość</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:building-community'" class="text-gray-400 mr-2"></mat-icon>
                  <input type="text" formControlName="city" placeholder="Warszawa" matInput>
                  <mat-error *ngIf="secondForm.controls['city'].hasError('required')">Miejscowość jest wymagana</mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-12">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label>Kraj</mat-label>
                  <mat-icon matPrefix [svgIcon]="'tabler_outline:world'" class="text-gray-400 mr-2"></mat-icon>
                  <mat-select formControlName="countryCode" (selectionChange)="onCountryChange($event.value)">
                    <mat-option *ngFor="let country of countries" [value]="country.code">
                      {{ country.name }} ({{ country.code }})
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="secondForm.controls['countryCode'].hasError('required')">Kraj jest wymagany</mat-error>
                </mat-form-field>
              </div>
            </div>
          </form>

          <div class="flex gap-3 mt-8">
            <button mat-button color="primary" matStepperPrevious>
              <mat-icon [svgIcon]="'tabler_outline:arrow-left'" class="!w-5 !h-5 mr-1"></mat-icon>
              Wstecz
            </button>
            <button mat-flat-button color="primary" class="h-11" [disabled]="secondForm.invalid" matStepperNext>
              Dalej
              <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5 ml-1"></mat-icon>
            </button>
          </div>
        </mat-step>

        <!-- Krok 3: Konto bankowe -->
        <mat-step [stepControl]="thirdForm" label="Konto bankowe" state="edit">
          <ng-template matStepperIcon="edit">
            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4"></mat-icon>
          </ng-template>
          
          <form [formGroup]="thirdForm" class="mt-4">
            <div *ngIf="dataLoadedFromGUS && accountNumbers?.length > 0" class="mb-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-100 dark:border-green-800">
              <div class="flex items-start gap-2 text-green-700 dark:text-green-300 text-sm">
                <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4 mt-0.5 flex-shrink-0"></mat-icon>
                <span>Znaleźliśmy konta bankowe powiązane z Twoim NIP w bazie Ministerstwa Finansów. Wybierz domyślne konto do przelewów.</span>
              </div>
            </div>

            <div *ngIf="accountNumbers?.length == 0" class="mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-100 dark:border-amber-800">
              <div class="flex items-start gap-2 text-amber-700 dark:text-amber-300 text-sm">
                <mat-icon [svgIcon]="'tabler_outline:info-circle'" class="!w-4 !h-4 mt-0.5 flex-shrink-0"></mat-icon>
                <span>Nie znaleźliśmy kont bankowych powiązanych z tym NIP. Możesz dodać numer konta później w ustawieniach.</span>
              </div>
            </div>

            <mat-radio-group formControlName="bankAccountNumber" color="primary" class="flex flex-col gap-3">
              <label *ngFor="let b of accountNumbers" 
                     class="flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all hover:border-gray-300"
                     [ngClass]="thirdForm.controls.bankAccountNumber.value === b.accountNumber 
                       ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20' 
                       : 'border-gray-200 dark:border-gray-700'">
                <mat-radio-button [value]="b.accountNumber" class="flex-shrink-0"></mat-radio-button>
                <div class="flex-1 min-w-0">
                  <div class="font-medium text-gray-900 dark:text-white">{{b.bank}}</div>
                  <div class="text-sm text-gray-500 dark:text-gray-400 font-mono truncate">{{b.accountNumber}}</div>
                </div>
                <mat-icon [svgIcon]="'tabler_outline:building-bank'" class="!w-6 !h-6 text-gray-400 flex-shrink-0"></mat-icon>
              </label>

              <label class="flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all hover:border-gray-300"
                     [ngClass]="thirdForm.controls.bankAccountNumber.value === '0' 
                       ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20' 
                       : 'border-gray-200 dark:border-gray-700'">
                <mat-radio-button value="0" class="flex-shrink-0"></mat-radio-button>
                <div class="flex-1">
                  <div class="font-medium text-gray-900 dark:text-white">Dodam później</div>
                  <div class="text-sm text-gray-500 dark:text-gray-400">Pomiń ten krok i dodaj konto w ustawieniach</div>
                </div>
                <mat-icon [svgIcon]="'tabler_outline:clock'" class="!w-6 !h-6 text-gray-400 flex-shrink-0"></mat-icon>
              </label>
            </mat-radio-group>
          </form>

          <div class="flex gap-3 mt-8">
            <button mat-button color="primary" matStepperPrevious>
              <mat-icon [svgIcon]="'tabler_outline:arrow-left'" class="!w-5 !h-5 mr-1"></mat-icon>
              Wstecz
            </button>
            <button mat-flat-button color="primary" class="h-11" (click)="save()">
              <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-5 !h-5 mr-1"></mat-icon>
              Zakończ konfigurację
            </button>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </ng-container>
</div>
